export default __webpack_public_path__ + "static/media/post-3.dd5836e2.png";